export default {
  isAdmin: (state) => parseInt(state.userRoleId, 10) === 1,
  isSales: (state) => parseInt(state.userRoleId, 10) === 4,
  isSuperAdmin: (state) => [1, 2, 480].includes(parseInt(state.userId, 10)),
  isTravelAgency: (state) => parseInt(state.agencyType, 10) === 2,
  isTravelOperator: (state) => state.isTravelOperator,
  canSendRequests: (state) => state.canSendRequests,
};
